import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./libs/i18n";
import reportWebVitals from "./reportWebVitals";
import "./styles/tailwind.css";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

reportWebVitals(null);
